import { ReactComponent as CalendarSvg } from '../../../../assets/icons/Calendar.svg';

import { createIconComponent } from './createIconComponent';

export const CalendarIcon = createIconComponent(CalendarSvg);
